import type { Product } from '../generated/graphql'
import { dateIsInPast } from '@twlvxtwlv/utils/src/date'

export function getHasReachedClaimableFromDate(product: Product): boolean {
  const whitelistableFrom = product?.whitelistable

  return whitelistableFrom ? dateIsInPast(whitelistableFrom) : false
}
